import { Action } from 'redux';

import { RunExtractRefreshNow } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface RunExtractRefreshNowAction extends Action {
    tasks: IContentInfo[];
}

export function runExtractRefreshNow(tasks: IContentInfo[]): RunExtractRefreshNowAction {
  return {
    type: RunExtractRefreshNow,
    tasks
  };
}
